export const getAuth = () => {
    return { headers: { 'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}` } };
};